import { ViewRoom } from '../models'

type CopyRoom = Omit<ViewRoom, 'id' | 'tables'> & {
  tables: Omit<ViewRoom['tables'][number], 'id'>[]
}

export const copyRoom = (room: ViewRoom): CopyRoom => {
  const { id, ...roomWithoutId } = room
  const copyRoom: CopyRoom = {
    ...roomWithoutId,
    name: `${room.name} (Kopie)`,
    order: -1, // Reset order so backend assigns next available order
    settings: { ...room.settings },
    tables: room.tables.map((t) => {
      const { id, combinableTables, ...tableWithoutId } = t
      return { ...tableWithoutId, combinableTables: [] }
    }),
  }
  return copyRoom
}
